module.exports = __webpack_public_path__ + "img/Large-Semi-Elliptical-Attachment-L-42.8e0f76ea.png";